window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.AjaxProjets = (function AjaxProjets() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  const $projectsTags = document.querySelectorAll('[data-ajax-projets]');

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    if ($projectsTags.length) {
      $projectsTags.forEach(tag => {

        tag.addEventListener('click', function(e){
          e.preventDefault();

          let oldTag = document.querySelector('.project-filter.is-active');
          oldTag.classList.remove('is-active');

          tag.classList.add('is-active');

          const $ajaxZone = document.querySelector('.project-entries-wrapper');

          const $loader = '<div class="loader-container" style="height: ' + $ajaxZone.clientHeight + 'px;"><div class="loader"><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div></div>';
          const apiURL = tag.getAttribute('href');

          $ajaxZone.innerHTML = $loader;

          console.log(apiURL);

          fetch(apiURL, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'GET'
          })
            .then((resp) => resp.text())
            .then(function(data) {

              if (data) {

                // Fetch and transform response to an HTML object
                const htmlResponse = document.createElement('div');
                htmlResponse.innerHTML = data;

                const $refreshArticle = htmlResponse.querySelector('.project-entries-wrapper').innerHTML;
                $ajaxZone.innerHTML = $refreshArticle;
              }
            });
        });
      });

    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
